import React, {forwardRef, useEffect, useImperativeHandle, useState} from "react";
import LoadingSpinner from "../../LoadingSpinner";
import {FORMS, MODULES} from "../../../const";
import Dropdown from "../../input/Dropdown";
import {
    getBulkDropdownData,
    getFieldValuesByTableAndId,
    getOtherRefSearchDropdown,
    getTextByValueAndKey
} from "../../../api/keyvalue";
import SearchDropdown from "../../input/SearchDropdown";
import {vehicleAssignmentSearch} from "../../../api/jobApi";
import Input from "../../input/Input";
import Button from "../../input/Button";
import {ActiveCellStyle, ResizableScrollingTextRenderer, StatusCellStyle} from "../../renderer/StyleRenderer";
import ButtonRenderer from "../../renderer/ButtonRenderer";
import Grid from "../../Grid";
import {
    stakeholderVehicleTypeCustomerValidation, stakeholderVehicleTypeShipperValidation,
    stakeholderVehicleTypeValidation,
    stakeholderVehicleValidation
} from "../../validations/StakeholderVehicleCreation";
import useUserCompany from "../../../hooks/useUserCompany";
import {vehicleTypeById} from "../../../api/vehicleapi";
import {toast} from "react-toastify";
import {findUserCustomerByUserAndStakeholderAndActive} from "../../../api/UserCustomerApi";
import {
    findStakeholderVehicleType,
    findStkVehicleTypeByStkAndVehTypeAndActive
} from "../../../api/stakeholderVehicleApi";
import DeleteButtonRenderer from "../../renderer/DeleteButtonRenderer";
const FORM = FORMS.STAKEHOLDER.STK_VEH.form;

const StakeholderVehicleTypeForm = forwardRef(
    ({dropdown ,isLoading, currentValues, editMode }, ref) => {
        const userCompany = useUserCompany();
        const [company, setCompany] = useState(
            userCompany ? userCompany.comId : null
        );

        useEffect(() => {
            setCompany(userCompany ? userCompany.comId : null);
        }, [userCompany]);

        const [stakeholderVehTypeData, setStakeholderVehTypeData] = useState(
            editMode
                ? {

                    svtStakeholderType : currentValues[0]?.svtStakeholderType,
                    svtStakeholder : currentValues[0]?.svtStakeholder,
                    svtCustomerShipper : "",
                    svtStatus : 2,
                    svtActive : 1,
                    svtLoadingTime:"",
                    svtUnloadingTime:"",
                    svtUnitCostForPlanning:"",
                    svtDailyThreshold: "",
                    svtKpiMinutes: "",
                    svtVehicleTypeName:"",
                    svtVehicleType : "",
                    svtCompany: company,
                }:{

                    svtStakeholderType : "",
                    svtStakeholder : "",
                    svtCustomerShipper : "",
                    svtVehicleType : "",
                    svtDescription : "",
                    svtStatus : 2,
                    svtActive : 1,
                    svtStakeholderTypeName : "",
                    svtStakeholderName : "",
                    svtVehicleTypeName: "",
                    svtCustomerShipperName: "",
                    svtLoadingTime:"",
                    svtUnloadingTime:"",
                    svtUnitCostForPlanning:"",
                    svtDailyThreshold: "",
                    svtKpiMinutes: "",
                    svtCompany: company,
                }
        )


        const [currentErrors, setCurrentErrors] = useState({});
        const [currentStkVehType, setCurrentStkVehType] = useState({});

        //counter
        const [stkVehTypeCount, setStkVehTypeCount] = useState(2);


        // flags
        const [fieldReset, setFieldReset] = useState(false);
        const [vehicleFieldReset, setVehicleFieldReset] = useState(false);
        const [buttonClicked, setButtonClicked] = useState(false);
        const [isAddLoading, setIsAddLoading] = useState(false);
        const [stakeholderType, setStakeholderType] = useState(false);
        const [stkFieldReset, setStkFieldReset] = useState(false);
        const [shipperFieldReset, setShipperFieldReset] = useState(false);

        const [stkVehType, setStkVehType] = useState([]);
        const [deletedList, setDeletedList] = useState([]);

        const [stakeTypeOptions, setStakeTypeOptions] = useState([]);
        const [selectedStakeholder, setSelectedStakeholder] = useState([]);

        useEffect(() => {
            (async () => {
                //new
                const {
                    stakeholder_type: typeData,
                } = await getBulkDropdownData([
                    { key: "stakeholder_type" },
                ]);
                const stkTypes = [1,2]
                const stakeholderTypeOpt = typeData.filter((typ) =>
                    stkTypes.includes(typ.key)
                );
                setStakeTypeOptions(stakeholderTypeOpt);
            })();
        }, []);

        useEffect(() => {
            if (buttonClicked) {
                if (editMode) {
                    setStakeholderVehTypeData({
                        svtStakeholderType : currentValues[0]?.svtStakeholderType,
                        svtStakeholder : currentValues[0]?.svtStakeholder,
                        svtVehicle : "",
                        svtDescription : "",
                        svtStatus : 2,
                        svtActive : 1,
                        svtVehicleTypeName: "",
                    });
                } else {
                    setStakeholderVehTypeData({
                        svtStakeholderType : "",
                        svtStakeholder : "",
                        svtVehicle : "",
                        svtDescription : "",
                        svtStatus : 2,
                        svtActive : 1,
                        svtStakeholderTypeName : "",
                        svtStakeholderName : "",
                        svtVehicleTypeName: "",
                    });
                    setStkFieldReset(true);
                }
                setFieldReset(true);
                setShipperFieldReset(true);


                setButtonClicked(false);
                setCurrentStkVehType({});
            }
        }, [buttonClicked]);

        useEffect(() => {
            (async () => {
                if (editMode && currentValues) {
                    let currentStkVehType = [];
                    let id = 2;
                    for (let currentValue of currentValues) {

                        const svtStatusValue = await getTextByValueAndKey(
                            "status",
                            currentValue.svtStatus
                        );
                        const svtActiveValue = await getTextByValueAndKey(
                            "active",
                            currentValue.svtActive
                        );
                        const stkTypeValue = await getTextByValueAndKey(
                            "stakeholder_type",
                            currentValue.svtStakeholderType
                        );
                        const stakeholder = await getFieldValuesByTableAndId({
                            tableName: "masterdata.tms_m_stakeholder",
                            primaryKey: "stk_id",
                            fieldNames: "stk_name",
                            ids: currentValue.svtStakeholder,
                        });
                        const stakeholderName = stakeholder[0].field1;
                        let customerShipperName = "";
                        if(currentValue.svtStakeholderType === 2) {
                            customerShipperName = await getOtherRefSearchDropdown(
                                {
                                    type: "stakeholder_type",
                                    value: "customer_shipper",
                                    param1: currentValue.svtCustomerShipper?.toString()
                                }
                            )
                        }
                        const vetTypeObj = await vehicleTypeById(currentValue.svtVehicleType);
                        const vehicleTypeName = vetTypeObj !== null ? vetTypeObj.vhtType : "";

                        setStakeholderType(currentValue.svtStakeholderType);

                        currentStkVehType.push({
                            ...currentValue,
                            status: svtStatusValue,
                            active: svtActiveValue,
                            svtStakeholderTypeName: stkTypeValue,
                            svtStakeholderName: stakeholderName,
                            svtVehicleTypeName: vehicleTypeName,
                            svtCustomerShipperName: currentValue.svtStakeholderType === 2 ? customerShipperName[0]?.title : "",
                            id,
                        });
                        ++id;
                    }
                    setStkVehTypeCount(id);
                    setStkVehType(currentStkVehType);
                }
            })();
        }, [editMode, currentValues]);

        const onAddClick = async () => {
            setIsAddLoading(true);
            const stkVehTypeCusErrors = stakeholderVehicleTypeCustomerValidation({
                ...stakeholderVehTypeData,
            });
            let stkVehTypeShpErrors = [];
            if ( stakeholderVehTypeData.svtStakeholderType === 2 ) {
                stkVehTypeShpErrors = stakeholderVehicleTypeShipperValidation({
                    ...stakeholderVehTypeData,
                });
            }

            console.log("stkVehTypeCusErrors",stakeholderVehTypeData)
            if (Object.keys(stkVehTypeCusErrors).length === 0 && Object.keys(stkVehTypeShpErrors).length === 0) {

                const response =
                    await findStakeholderVehicleType(stakeholderVehTypeData);

                if (
                    Object.keys(currentStkVehType).length >= 0 &&
                    stkVehType.some(
                        (vt) =>
                            vt?.svtVehicleType === stakeholderVehTypeData.svtVehicleType &&
                            vt?.svtStakeholder === stakeholderVehTypeData.svtStakeholder &&
                            vt?.svtStakeholderType === stakeholderVehTypeData.svtStakeholderType &&
                            vt?.svtCustomerShipper === stakeholderVehTypeData.svtCustomerShipper &&
                            vt?.id !== stakeholderVehTypeData.id
                    )
                ){
                    toast.error(
                        "There was an error adding vehicle type already added to grid!",
                        { autoClose: 5000, containerId: "Main" }
                    );
                    setIsAddLoading(false);
                }

                else {
                    if ((!stakeholderVehTypeData.id || stakeholderVehTypeData.id === null) && response !== "") {
                        toast.error(
                            "There was an error adding vehicle type already exists!",
                            { autoClose: 5000, containerId: "Main" }
                        );
                    } else {
                        const svtStatusValue = await getTextByValueAndKey(
                            "status",
                            stakeholderVehTypeData.svtStatus
                        );
                        const svtActiveValue = await getTextByValueAndKey(
                            "active",
                            stakeholderVehTypeData.svtActive
                        );
                        const stkTypeValue = await getTextByValueAndKey(
                            "stakeholder_type",
                            stakeholderVehTypeData.svtStakeholderType
                        );
                        const stakeholder = await getFieldValuesByTableAndId({
                            tableName: "masterdata.tms_m_stakeholder",
                            primaryKey: "stk_id",
                            fieldNames: "stk_name",
                            ids: stakeholderVehTypeData.svtStakeholder,
                        });
                        const stakeholderName = stakeholder[0].field1;

                        const customerShipperName = await getOtherRefSearchDropdown(
                            {
                                type:"stakeholder_type",
                                value:"customer_shipper",
                                param1:stakeholderVehTypeData.svtCustomerShipper?.toString()
                            }
                        )


                        const vetTypeObj = await vehicleTypeById(stakeholderVehTypeData.svtVehicleType);
                        const vehicleTypeName = vetTypeObj !== null ? vetTypeObj.vhtType : "";


                        if (
                            !stakeholderVehTypeData.svtId ||
                            stakeholderVehTypeData.svtId === null
                        ) {
                            if (!stakeholderVehTypeData.id || stakeholderVehTypeData.id === null) {
                                setStkVehType((prevState) => [
                                    ...prevState,
                                    {
                                        ...stakeholderVehTypeData,
                                        status: svtStatusValue,
                                        active: svtActiveValue,
                                        svtStakeholderTypeName: stkTypeValue,
                                        svtStakeholderName: stakeholderName,
                                        svtVehicleTypeName: vehicleTypeName,
                                        svtCustomerShipperName: stakeholderVehTypeData.svtStakeholderType === 2 ?customerShipperName[0]?.title : null,
                                        svtCompany: company,
                                        id: stkVehTypeCount,
                                    },
                                ]);
                                setStkVehTypeCount((prevState) => ++prevState);

                            } else {
                                setStkVehType((prevState) =>
                                    prevState.filter((item) => item.id !== stakeholderVehTypeData.id)
                                );
                                setStkVehType((prevState) => [
                                    ...prevState,
                                    {
                                        ...stakeholderVehTypeData,
                                        status: svtStatusValue,
                                        active: svtActiveValue,
                                        svtStakeholderTypeName: stkTypeValue,
                                        svtStakeholderName: stakeholderName,
                                        svtVehicleTypeName: vehicleTypeName,
                                        svtCustomerShipperName:stakeholderVehTypeData.svtStakeholderType === 2 ?customerShipperName[0]?.title : null,
                                        svtCompany: company,
                                    },
                                ]);
                            }
                        } else {
                            setStkVehType((prevState) =>
                                prevState.filter(
                                    (item) => item.svtId !== stakeholderVehTypeData.svtId
                                )
                            );

                            setStkVehType((prevState) => [
                                ...prevState,
                                {
                                    ...stakeholderVehTypeData,
                                    status: svtStatusValue,
                                    active: svtActiveValue,
                                    svtStakeholderTypeName: stkTypeValue,
                                    svtStakeholderName: stakeholderName,
                                    svtVehicleTypeName: vehicleTypeName,
                                    svtCustomerShipperName: stakeholderVehTypeData.svtStakeholderType === 2 ?customerShipperName[0]?.title : null,
                                    svtCompany: company,
                                    modified: true,
                                },
                            ]);
                        }
                        setVehicleFieldReset(true);
                        setButtonClicked(true);
                    }
                }
            }
            setCurrentErrors(stakeholderVehTypeData.svtStakeholderType === 2 ? stkVehTypeShpErrors :stkVehTypeCusErrors);
            setIsAddLoading(false);
        }
        useEffect(() => {
            if (Object.keys(currentStkVehType).length > 0) {
                if (editMode) {
                    setStakeholderVehTypeData({
                        ...currentStkVehType,
                    });
                } else {
                    setStakeholderVehTypeData({
                        ...currentStkVehType,
                    });
                }
            }
        }, [editMode, currentStkVehType]);

        useEffect(() => {
            (async () => {
                const selectedStakeholder = await getTextByValueAndKey(
                    "stakeholder_type",
                    stakeholderType
                );
                setSelectedStakeholder(selectedStakeholder);
            })();
        }, [stakeholderType]);

        useImperativeHandle(ref, () => ({
            getData: () => {
                if (editMode) {
                    const updateState = {
                        modified: [],
                        created: [],
                        unmodified: [],
                        deleted: deletedList,
                    };
                    stkVehType.forEach((svt) => {
                        if (svt.svtId && svt.svtId !== null) {
                            if (svt.modified) {
                                updateState.modified.push(svt);
                            } else {
                                updateState.unmodified.push(svt);
                            }
                        } else {
                            updateState.created.push(svt);
                        }
                    });
                    return updateState;
                }else {
                    return stkVehType;
                }
            },
            resetForm: () => {
                setButtonClicked(true);
                setStkVehType([]);
            },
        }));

        return(
            <>
                {isLoading ? (
                    <LoadingSpinner />
                ) : (
                    <form
                        className="ui form"
                        style={{overflowY: "auto", height: "75vh"}}
                    >
                        <div className="ui segment">
                            <div className="two fields">
                                <Dropdown
                                    required={true}
                                    label="Type"
                                    error={currentErrors.svtStakeholderType}
                                    editMode={editMode}
                                    module={MODULES.Master}
                                    form={FORM}
                                    field="typ_type"
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const {svtStakeholderType: _, ...rest} = prevState;
                                            return rest;
                                        })
                                    }
                                    placeholder="(Customer/Shipper)"
                                    options={stakeTypeOptions}
                                    style={{height: "20px"}}
                                    value={stakeholderVehTypeData.svtStakeholderType}
                                    onChange={(e, data) => {
                                        setStakeholderVehTypeData((prevState) => ({
                                            ...prevState,
                                            svtStakeholderType: data.value,
                                            svtCustomerShipperName: null,
                                            svtCustomerShipper: null,
                                            svtStakeholder: null,
                                            svtKpiMinutes: null,
                                        }));
                                        setStakeholderType(data.value)
                                        setStkFieldReset(true);
                                    }}
                                    disabled={editMode}
                                />
                                <SearchDropdown
                                    required={true}
                                    editMode={editMode}
                                    multiGrid={true}
                                    multiGridCurrentValue={stakeholderVehTypeData.svtStakeholderName}
                                    reset={stkFieldReset}
                                    setReset={setStkFieldReset}
                                    clearable={true}
                                    onClear={() => {
                                        setStakeholderVehTypeData((prevState) => ({
                                            ...prevState,
                                            svtStakeholder: null,
                                        }));
                                    }}
                                    onResultSelect={(data) =>{
                                        setStakeholderVehTypeData((prevState) => ({
                                            ...prevState,
                                            svtStakeholder: data,
                                            svtCustomerShipperName: null,
                                            svtCustomerShipper: null,

                                        }));
                                        setShipperFieldReset(true);
                                    }}
                                    api={getOtherRefSearchDropdown}
                                    apiDependency={{
                                        type: "stakeholder_type",
                                        value: "customer"
                                    }}
                                    fieldInfo={{
                                        tableName: "masterdata.tms_m_stakeholder",
                                        primaryKey: "stk_id",
                                        fieldName: "stk_name",
                                        id: stakeholderVehTypeData.svtStakeholder,
                                    }}
                                    error={currentErrors.svtStakeholder}
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const {svtStakeholder: _, ...rest} = prevState;
                                            return rest;
                                        })
                                    }
                                    label="Customer"
                                    disabled={editMode}
                                />
                            </div>
                            <div className="two fields">
                                <SearchDropdown
                                    disabled={selectedStakeholder !== "Shipper" }
                                    required={selectedStakeholder === "Shipper"}
                                    editMode={editMode}
                                    multiGrid={true}
                                    multiGridCurrentValue={stakeholderVehTypeData.svtCustomerShipperName}
                                    reset={shipperFieldReset}
                                    setReset={setShipperFieldReset}
                                    clearable={true}
                                    onClear={() => {
                                        setStakeholderVehTypeData((prevState) => ({
                                            ...prevState,
                                            svtCustomerShipper: null,
                                        }));
                                    }}
                                    onResultSelect={(data) =>
                                        setStakeholderVehTypeData((prevState) => ({
                                            ...prevState,
                                            svtCustomerShipper: data,
                                        }))
                                    }
                                    api={getOtherRefSearchDropdown}
                                    apiDependency={{
                                        type: "stakeholder_type",
                                        value: "customer_shipper",
                                        param2: stakeholderVehTypeData.svtStakeholder?.toString()
                                    }}
                                    //stakeholderVehTypeData.svtStakeholderType !== 2 ?
                                    // fieldInfo={{
                                    //     tableName: "masterdata.tms_m_stakeholder",
                                    //     primaryKey: "stk_id",
                                    //     fieldName: "stk_name",
                                    //     id: stakeholderVehTypeData.svtCustomerShipper,
                                    // }}
                                    error={currentErrors.svtCustomerShipper}
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const {svtCustomerShipper: _, ...rest} = prevState;
                                            return rest;
                                        })
                                    }
                                    label="Customer Shipper"
                                />
                            </div>
                            <div className="two fields">
                                <SearchDropdown
                                    required={true}
                                    editMode={editMode}
                                    reset={fieldReset}
                                    setReset={setFieldReset}
                                    multiGrid={true}
                                    multiGridCurrentValue={stakeholderVehTypeData.svtVehicleTypeName}
                                    field="svt_vehicle_type"
                                    clearable={true}
                                    onClear={() => {
                                        setStakeholderVehTypeData((prevState) => ({
                                            ...prevState,
                                            svtVehicleType: null,

                                        }));
                                    }}
                                    onResultSelect={(data) => {
                                        setStakeholderVehTypeData((prevState) => ({
                                            ...prevState,
                                            svtVehicleType: data,
                                        }));
                                    }}
                                    api={getOtherRefSearchDropdown}
                                    apiDependency={{
                                        type: "vehicle_type",
                                        value: "",
                                    }}
                                    label="Vehicle Type"
                                    fieldInfo={{
                                        tableName: "masterdata.tms_m_vehicle_type",
                                        primaryKey: "vht_id",
                                        fieldName: "vht_type",
                                        id: stakeholderVehTypeData.svtVehicleType,
                                    }}

                                    error={currentErrors.svtVehicleType}
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const {svtVehicleType: _, ...rest} = prevState;
                                            return rest;
                                        })
                                    }
                                />
                                    <Input
                                        label="KPI Minutes"
                                        name="svtKpiMinutes"
                                        type="number"
                                        step="0.01"
                                        min={0}
                                        value={stakeholderVehTypeData.svtKpiMinutes}
                                        error={currentErrors.svtKpiMinutes}
                                        onChange={(e) => {
                                            setStakeholderVehTypeData((prevState) => ({
                                                ...prevState,
                                                svtKpiMinutes: e.target.value,
                                            }));
                                        }}
                                    />
                            </div>
                            <div className="two fields">
                                <Input
                                    label="Loading Time (Hours)"
                                    field="svt_loading_time"
                                    name="svtLoadingTime"
                                    type="number"
                                    min={0}
                                    value={stakeholderVehTypeData.svtLoadingTime}
                                    onChange={(e) => {
                                        setStakeholderVehTypeData((prevState) => ({
                                            ...prevState,
                                            svtLoadingTime: e.target.value,
                                        }));
                                    }}
                                />
                                <Input
                                    label="Unloading Time (Hours)"
                                    field="svt_unloading_time"
                                    name="svtUnloadingTime"
                                    type="number"
                                    min={0}
                                    value={stakeholderVehTypeData.svtUnloadingTime}
                                    onChange={(e) => {
                                        setStakeholderVehTypeData((prevState) => ({
                                            ...prevState,
                                            svtUnloadingTime: e.target.value,
                                        }));
                                    }}
                                />

                            </div>
                            <div className="two fields">
                                <Input
                                    label="Description"
                                    name="svtDescription"
                                    value={stakeholderVehTypeData.svtDescription}
                                    onChange={(e) => {
                                        setStakeholderVehTypeData((prevState) => ({
                                            ...prevState,
                                            svtDescription: e.target.value,
                                        }));
                                    }}
                                />
                            </div>
                            <div className="two fields">
                                <Dropdown
                                    required={true}
                                    label="Status"
                                    error={currentErrors.svtStatus}
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const {svtStatus: _, ...rest} = prevState;
                                            return rest;
                                        })
                                    }
                                    placeholder="Status"
                                    options={dropdown.statusOptions}
                                    style={{height: "20px"}}
                                    value={stakeholderVehTypeData.svtStatus}
                                    onChange={(e, data) => {
                                        setStakeholderVehTypeData((prevState) => ({
                                            ...prevState,
                                            svtStatus: data.value,
                                        }));
                                    }}
                                />
                                {/* <Dropdown
                                    required={true}
                                    label="Active"
                                    error={currentErrors.svtActive}
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const {cshActive: _, ...rest} = prevState;
                                            return rest;
                                        })
                                    }
                                    placeholder="Active"
                                    options={dropdown.activeOptions}
                                    style={{height: "20px"}}
                                    value={stakeholderVehTypeData.svtActive}
                                    onChange={(e, data) => {
                                        setStakeholderVehTypeData((prevState) => ({
                                            ...prevState,
                                            svtActive: data.value,
                                        }));
                                    }}
                                /> */}
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "100%",
                                    justifyContent: "flex-end",
                                    gap: "5px",
                                }}
                            >
                                <Button
                                    template="reset"
                                    onClick={(e) => {
                                        setButtonClicked(true);
                                    }}
                                />
                                <Button
                                    template="addOrSave"
                                    create={Object.keys(currentStkVehType).length === 0}
                                    onClick={onAddClick}
                                    isLoading={isAddLoading}
                                />
                            </div>
                            <Grid
                                heading="Stakeholder Vehicle Type"
                                config={[
                                    {
                                        headerName: "Stakeholder Type",
                                        field: "svtStakeholderTypeName"
                                    },
                                    {
                                        headerName: "Stakeholder",
                                        field: "svtStakeholderName",
                                        cellRenderer: ResizableScrollingTextRenderer,
                                    },
                                    {
                                        headerName: "Customer Shipper",
                                        field: "svtCustomerShipperName",
                                        cellRenderer: ResizableScrollingTextRenderer,
                                    },
                                    {
                                        headerName: "Vehicle Type Details",
                                        field: "svtVehicleTypeName",
                                        cellRenderer: ResizableScrollingTextRenderer,
                                        minWidth: 350,
                                    },
                                    {
                                        headerName: "Description",
                                        field: "svtDescription",
                                    },
                                    {
                                        headerName: "KPI Minutes",
                                        field: "svtKpiMinutes",
                                    },
                                    {
                                        headerName: "Status",
                                        field: "status",
                                        cellRenderer: StatusCellStyle,
                                    },
                                    {
                                        headerName: "Active",
                                        field: "active",
                                        cellRenderer: ActiveCellStyle,
                                    },
                                    {
                                        field: "Edit",
                                        filter: true,
                                        cellRenderer: ButtonRenderer,
                                        cellRendererParams: (params) => ({
                                            clickHandler: () => {
                                                setCurrentStkVehType(params.data);
                                            },
                                            label: "Edit",
                                        }),
                                    },
                                    {
                                        field: "Delete",
                                        filter: true,
                                        cellRenderer: DeleteButtonRenderer,
                                        cellRendererParams: (params) => ({
                                            clickHandler: () => {
                                                if (params.data.svtId && params.data.svtId !== null) {
                                                    setDeletedList((prevState) => [
                                                        ...prevState,
                                                        params.data.svtId,
                                                    ]);
                                                }
                                                setStkVehType((prevState) =>
                                                    prevState.filter(
                                                        (stkVehType) => stkVehType.id !== params.data.id
                                                    )
                                                );
                                            },
                                            message:
                        "Are you sure you want to delete this Stakeholder Vehicle Type?",
                                            label: "Delete",
                                            className: "ui red button",
                                        }),
                                    },
                                ]}
                                content={stkVehType}
                            />
                        </div>
                    </form>
                )}
            </>
        );
    }
);
export default StakeholderVehicleTypeForm;
